<div class="d-flex flex-column gap-1">
  <div class="comment-body">{{ comment.comment }}</div>
  <div class="d-flex flex-wrap align-items-center" [style.gap.rem]="0.75">
    <div class="d-flex gap-2 align-items-center">
      <app-user-profile-badge
        [initials]="comment.author.initials"
        [profileBadgeConfiguration]="comment.author.profileBadgeConfiguration" />
      <div class="comment-meta">{{ comment.author.fullName }}</div>
    </div>
    <div class="comment-meta">{{ comment.formattedDate }}</div>
  </div>
</div>
